export default requester => {
    return {
        /**
         * Get the completed challenges for the home page.
         *
         * @param  {object}  params
         * @return {object}
         * @deprecated
         */
        completedChallenges(params = {}) {
            return requester.get('/widgets/completed-challenges', { params });
        },

        /**
         * Get the open challenges for the home page.
         *
         * @param {Object} params
         * @return {object}
         * @deprecated
         */
        openChallenges(params = {}) {
            return requester.get('/widgets/challenges-homepage', { params });
        },

        /**
         * Get the open challenges for the home page.
         *
         * @param {String} platform
         * @param {Object} params
         * @return {object}
         */
        challenges(platform, params = {}, config = {}) {
            return requester.get(`/${platform}/challenges-homepage`, { ...config, params });
        },

        /**
         * Get the challenges for the home page (v2).
         *
         * @param {String} platform
         * @param {Object} params
         * @param {Object} config
         * @return {object}
         */
        challengesV2(platform, params = {}, config = {}) {
            return requester.get(`/${platform}/challenges-homepage/v2`, { ...config, params });
        },

        /**
         * Get a specific challenge for the home page (v2).
         *
         * @param {String} platform
         * @param {String} id
         * @param {Object} params
         * @param {Object} config
         * @return {object}
         */
        challengesV2ById(platform, id) {
            return requester.get(`/${platform}/challenges-homepage/v2/${id}`);
        },

        /**
         * Get the olympiad for the home page.
         *
         * @param  {object}  params
         * @return {object}
         */
        olympiads(target, params = {}) {
            return requester.get(`/widgets/olympiads/${target}`, { params });
        },

        /**
         * Get the categories for the home page.
         *
         * @param  {object}  params
         * @return {object}
         */
        categories(params = {}) {
            return requester.get('/widgets/categories', { params });
        },

        /**
         * Get follow widget.
         */
        follow(params = {}) {
            return requester.get('/widgets/follow', { params });
        },
    };
}
